import { render, staticRenderFns } from "./ArtisanRadio.vue?vue&type=template&id=da188e50"
import script from "./ArtisanRadio.vue?vue&type=script&lang=js"
export * from "./ArtisanRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports